module.exports = "../../graphooo.JPG";